export function isESModule(obj) {
  return obj && obj.__esModule;
}